import React from "react";
import Dropdown from "../Dropdown/dropdown";
import { getSelectedOptionFromValue } from "../../Helper/options.helper";
import { useGetSchoolBranchesOptions } from "../../hooks/branchHooks/branch.hooks";

interface IProps {
  onBranchSelect: (selectedClass: any) => unknown;
  selectedBranchId: number | null;
}

export const BranchOptionsDropdown = ({
  onBranchSelect,
  selectedBranchId,
}: IProps) => {
  const { data: SCHOOL_BRANCH_OPTIONS } = useGetSchoolBranchesOptions();

  return (
    <Dropdown
      label="Branch"
      options={SCHOOL_BRANCH_OPTIONS || []}
      selectedOption={getSelectedOptionFromValue(
        SCHOOL_BRANCH_OPTIONS || [],
        selectedBranchId,
      )}
      setSelectedOption={(option) => {
        onBranchSelect(option);
      }}
    />
  );
};
